// extracted by mini-css-extract-plugin
export var skipAnimation = "_3p-0";